module.exports = __webpack_public_path__ + "img/pr2.a2394921.png";